import React from 'react';
import {Products} from 'api';
import style from './style.scss';
import {
  ListProductDetailImage,
  ProductInfo,
  ProductDetailCollapse,
  ListProductOther,
  ListProduct
} from './sub-view';
import {LoadingPage} from 'components/loading-page';
import {withRouter} from 'react-router-dom';
// import { AsyncConnect } from 'redux-connect';

class ProductDetail extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: this.useUpdatedInfo(this.props.product),
      isLoading: false
    };

  }

  // componentDidMount() {
  //   console.log(this.props.product)
  //   this.setState({data: this.useUpdatedInfo(this.props.product), isLoading: false});
  // }

  useUpdatedInfo(product) {
    if (product.requestUpdateInfo)
      return Object.assign({}, product, product.requestUpdateInfo);
    else {
      return product;
    }
  }


  render() {
    return (
      <section className="center">
        <LoadingPage isShow={this.state.isLoading} />
        <div className="product-detail">
          <div className='left-content-detail'>
            <div className='content-wrap mb20'>
              <div className='product-image-detail-container'>
                <ListProductDetailImage images={this.state.data.images}/>
              </div>
              <div className='product-info-container'>
                <ProductInfo {...this.state.data}/>
              </div>
            </div>
            <div className='content-wrap mb40'>
              <ProductDetailCollapse productContent={this.state.data.introduction}/>
            </div>

            <div className='bottom-content-detail mb40'>
              <ListProduct categoryId={this.state.data.categoryIds[0]} productId={this.state.data.id}/>
            </div>
          </div>
          <div className='right-content-detail mb40'>
            <div className='content-wrap'>
              {this.state.data.business && <ListProductOther businessId={this.state.data.businessId} productId={this.state.data.id}/>}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(ProductDetail);



// WEBPACK FOOTER //
// ./components/product-detail/ProductDetail.jsx